import { Events } from '@setplex/pureya'
import { createEvent, createStore, sample } from 'effector'
import { createAction } from 'effector-action'
import { delay } from 'patronum'
import { model as config, remote } from '~/shared/config'
import { model as mq, PLAYER } from '~/shared/mq'
import { PlayerMountedMessage } from '../player-meta'

const $enabled = config.get(remote.tria_isTrackAnalyticsCdnInfoEventEnabled)

const tryCdnInfo = createEvent()
export const cdnInfo = createEvent()

// delay a bit to ensure `player_open` event is processed before `cdn_info`
const playerMounted = delay(mq.on(PlayerMountedMessage), 0)
const playerDisposed = mq.on<void>(`${PLAYER}/dispose`)

export const manifestDownloaded = mq.on<{
  payload: Events.Media.MasterManifestDownloaded
}>(`${PLAYER}/${Events.Media.MasterManifestDownloaded}`)

const $playerMounted = createStore(false)
  .on(playerMounted, (_, { mounted }) => mounted)
  .on(playerDisposed, () => false)

const $awaitingPlayer = createStore(false)

createAction(manifestDownloaded, {
  source: $playerMounted,
  target: { $awaitingPlayer, tryCdnInfo },
  fn: (target, mounted) => {
    if (mounted) {
      target.tryCdnInfo()
    } else {
      target.$awaitingPlayer(true)
    }
  },
})

createAction($playerMounted, {
  source: $awaitingPlayer,
  target: { $awaitingPlayer, tryCdnInfo },
  fn: (target, awaiting, mounted) => {
    if (awaiting && mounted) {
      target.tryCdnInfo()
    } else {
      target.$awaitingPlayer(false)
    }
  },
})

sample({
  clock: tryCdnInfo,
  filter: $enabled,
  target: cdnInfo,
})
